import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import MenuIcon from "@mui/icons-material/Menu";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

/**
 * Sidebar menu for customer_type === 7 (service partner).
 * Home (with FAQ) + Management (DSOK Customers).
 */
export function getMenuList() {
  return [
    {
      label: "sidebar.menu.home",
      type: "section",
      icon: <HomeIcon sx={{ fontSize: 20 }} />,
      children: [
        {
          uri: "/",
          label: "sidebar.menuItem.home",
          type: "nav-item",
          icon: <HomeIcon sx={{ fontSize: 20 }} />,
        },
        {
          uri: "/dsok/faq",
          label: "sidebar.menuItem.faq",
          type: "nav-item",
          icon: <HelpOutlineIcon sx={{ fontSize: 20 }} />,
        },
      ],
    },
    {
      label: "sidebar.menu.management",
      type: "section",
      icon: <MenuIcon sx={{ fontSize: 20 }} />,
      children: [
        {
          uri: "/dsok/customers",
          label: "sidebar.menuItem.dsokCustomers",
          type: "nav-item",
          icon: <TouchAppIcon sx={{ fontSize: 20 }} />,
        },
      ],
    },
  ];
}
